export interface StudentLessonType {
  id: number;
  name: string;
}

export interface SameLevelClass {
  id: number;
  name: string;
}

export enum EvaluationChartType {
  Numeric = 'Numeric',
  Percent = 'Percent',
  AchievableResult = 'AchievableResult',
  Weighted = 'Weighted',
}

export interface EvaluationData {
  value: number;
  stringValue: string | null;
}

export interface DisciplineEvaluation {
  disciplineId: number;
  disciplineName: string;
  averageClassEvaluation: EvaluationData | null;
  averageStudentEvaluation: EvaluationData | null;
  isStudentEvaluationHigherOrEqualToClassEvaluation: boolean;
}

export interface AverageEvaluationsByDisciplineChart {
  chartValues: DisciplineEvaluation[];
  averageClassEvaluationTotal: EvaluationData | null;
  averageStudentEvaluationTotal: EvaluationData | null;
}

export interface StudentEvaluation {
  evaluation: EvaluationData;
  isCurrentStudent: boolean;
}

export interface StudentDisciplineChart {
  disciplineId: number | null;
  disciplineName: string | null;
  averageClassEvaluationTotal: EvaluationData | null;
  chartValues: StudentEvaluation[];
}

export interface RankingSubject {
  id: number | null;
  name: string;
}

export interface StudentAverageEvaluationsCharts {
  chartsByDiscipline: StudentDisciplineChart[];
  summaryChartForAllDisciplines: StudentDisciplineChart | null;
}

export interface EvaluationCharts {
  averageEvaluationsByDisciplineChart: AverageEvaluationsByDisciplineChart | null;
  studentAverageEvaluationsCharts: StudentAverageEvaluationsCharts | null;
}

export interface EvaluationChart {
  type: EvaluationChartType;
  charts: EvaluationCharts;
}
